// extracted by mini-css-extract-plugin
module.exports = {"bgImage":"App_bgImage__X0Zha","content":"App_content__1kxhD"};